/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function validateProductForm(btn) {
  let form = document.querySelector('form.ProductForm');

  let valid = true;

  if(form.querySelector('.custom-field')) {
    let i = 1;
    form.querySelectorAll('.custom-field').forEach(function(field) {
      let personalized = false;
      if(field.value.length >= 1) personalized = true;
      if(field.classList.contains('required') && field.value.length < 1) {
        valid = false;
        field.closest('.field-container').classList.add('error');
      }
      else if(field.classList.contains('required') && field.classList.contains('select') && field.value == '0' ) {
        valid = false;
        field.closest('.field-container').classList.add('error');
      }
      else {
        field.classList.remove('error');
        field.closest('.field-container').classList.remove('error');
      }

      if (personalized) {
        if(form.querySelector('input[name="properties[_personalized_'+i+']"]') == null) {
          let input = document.createElement("input");
          input.setAttribute('type', 'hidden');
          input.setAttribute('name', 'properties[_personalized_'+i+']');
          input.setAttribute('value', 'true');
          form.appendChild(input);
        }
        else {
          form.querySelector('input[name="properties[_personalized_'+i+']"]').value = 'true';
        }
      }
      i++;
    });
  }

  return valid;
}

(function ($) {

  $.fn.validateCartForm = function() {
    let btn = $(this);
    let form = btn.closest('form');

    let valid = true;

    if(form.find('#confirm-nonrefundable').length > 0) {
      valid = !!form.find('#confirm-nonrefundable').prop('checked');
      form.find('#confirm-nonrefundable').toggleClass('error', !valid);
      form.find('.confirm-nonrefundable-error').toggleClass('hidden', valid);
    }

    if(form.find('#team').length > 0) {
      form.find('.team-select').toggleClass('error', typeof form.find('#team option:selected').attr('value') == "undefined");
      form.find('.team-select .custom-field-error-msg').toggleClass('hidden', typeof form.find('#team option:selected').attr('value') == "undefined");

      if(typeof form.find('#team option:selected').attr('value') == "undefined") {
        valid = false;
      }
    }

    return valid;
  };

  if(document.querySelector(".Form__Input.custom-field")) {
    document.querySelectorAll(".Form__Input.custom-field").forEach(function(el) {
      el.addEventListener("keyup", (e) => {
        let field = e.target;
        if(field.classList.contains('required') && field.value.length < 1) {
          field.closest('.field-container').classList.add('error');
        }
        else if(field.classList.contains('required') && field.classList.contains('select') && field.value == '0' ) {
          field.closest('.field-container').classList.add('error');
        }
        else {
          field.classList.remove('error');
          field.closest('.field-container').classList.remove('error');
        }
      });
    });

  }

  $('.ProductForm__AddToCart').on('click', function(e) {
    let valid = validateProductForm($(this));
    if(!valid) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  });

  $(document).on('click', '.Cart__Checkout', function(e) {
    let valid = $(this).validateCartForm();
    if(!valid) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  });

  $(document).on('change', '#confirm-nonrefundable', function(e) {
    let el = $(this);
    if(el.hasClass('error') && el.prop('checked')) {
      el.removeClass('error');
      el.closest('form').find('.confirm-nonrefundable-error').addClass('hidden');
    }
    else if(!el.hasClass('error') && !el.prop('checked')) {
      el.addClass('error');
      el.closest('form').find('.confirm-nonrefundable-error').removeClass('hidden');
    }
  });

})(jQuery);

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
